import TeamLogo from './TeamLogo';
import TeamInfo from './TeamInfo';

const Item = ({ outcome, isLeft, isComplete, winningTeam }) => {
  const isWinner = isComplete && outcome.team === winningTeam;
  const scoreClass = `text-xl font-bold tabular-nums transition-colors duration-150 ${
    isWinner
      ? 'text-accent drop-shadow-sm'
      : isComplete
        ? 'text-muted-foreground'
        : 'text-foreground'
  }`;

  return (
    <div className="flex flex-col items-center space-y-2 min-w-[100px]">
      <div className={`flex items-center space-x-3 ${isLeft ? 'flex-row' : 'flex-row-reverse space-x-reverse'}`}>
        <TeamLogo logo={outcome.logo} team={outcome.team} isWinner={isWinner} />
        <TeamInfo outcome={outcome} scoreClass={scoreClass} isRight={!isLeft} isWinner={isWinner} />
      </div>
    </div>
  );
};

export default Item;
